import {Component, OnDestroy, OnInit} from '@angular/core';

import {NewNavigationService} from "@shared/services/new-navigation.service";
import {BaseComponent} from "@shared/components/base-component";

import {HandoverNotificationsService} from "@handover/routes/main-route/services/handover-notifications.service";
import { PermissionService } from '@shared/services/permission.service';

@Component({
  selector: 'handovermod-main-route',
  templateUrl: './main-route.component.html',
  styleUrls: ['./main-route.component.scss']
})
export class MainRouteComponent extends BaseComponent implements OnInit, OnDestroy {

  isStatementVisible = false;
  public hasAccessToHandover: boolean;

  constructor(
    private newNavigationService: NewNavigationService,
    private handoverNotificationsService: HandoverNotificationsService,
    private permissionService: PermissionService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.setPermissions();
    this.addToUnsubscribe(
      this.handoverNotificationsService.isWorkerStatementVisible$.subscribe(isVisible => this.isStatementVisible = isVisible)
    );
  }

  ngOnDestroy(): void {
    this.unsubscribeAll();
  }

  private setPermissions(): void {
    this.hasAccessToHandover = this.permissionService.hasHandover();
  }

  onClose() {
    this.newNavigationService.toMainPanel();
  }

  onShowStatement() {
    this.handoverNotificationsService.isWorkerStatementVisible$.next(true);
  }


}
